<mat-toolbar id="lms-header-container">
    <img
            width="48px"
            height="30px"
            src="../../../../assets/icons/leica.png"
            alt="logo"
    />
    <button *ngIf="showButton" class="back-btn-new" (click)="backClicked()">
        {{ currentRouteLabel }}
    </button>
    <span class="spacer"></span>
    <app-user-sub-region-selection></app-user-sub-region-selection>
    <em class="fa fa-user-circle" aria-hidden="true"></em>
    <button
            id="header"
            type="button"
            pButton
            icon="pi pi-chevron-down"
            iconPos="right"
            label="{{ selectedUser }}"
            (click)="menu.toggle($event)"
            class="header-btn"
    ></button>
    <p-menu #menu [popup]="true" [model]="items"></p-menu>
</mat-toolbar>
